import { Button, ButtonProps } from '@material-ui/core';
import React from 'react';

export type SecondaryButtonProps = ButtonProps & {
}

export function SecondaryButton (props: SecondaryButtonProps) {
    return <Button variant="contained" color="secondary" {...props} />
}